import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import './styles/TagsPost.scss';

const TagsPost = ({ tags }) => {
  return (
    <div className="tagPosts">
      {
        tags.map(tag => (
          <Link key={tag} to={`/tags/${tag}`} className="tagPosts-item" >
            {tag}
          </Link>
        ))
      }
    </div>
  );
};

TagsPost.propTypes = {
  tags: PropTypes.array,
}

export default TagsPost;



// WEBPACK FOOTER //
// ./src/components/TagsPost.jsx